export default {
  bankAccounts: 'not_set',
  pan: 'not_set',
  emails: 'not_set',
  phones: 'not_set',
  addresses: 'not_set'
};
